import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Router monitoring component
const RouterMonitor = ({ children }) => {
    const [currentPath, setCurrentPath] = useState(window.location.pathname);

    React.useEffect(() => {
        const checkRoute = () => {
            const newPath = window.location.pathname;
            
            // Always check and update for navigation and reload
            // console.log('Checking route:', newPath);
            
            // Check if current route contains /ThermalStep/ (case-insensitive)
            const isThermalStepRoute = newPath.toLowerCase().includes('/thermalstep/');
            
            if (isThermalStepRoute) {
                console.log('Thermal step route detected');
                document.body.classList.add('thermal-step-active');

                // Add Bootstrap CSS if not already present and page is loaded
                if (!document.querySelector('#bootstrap-css, link[href*="bootstrap"]')) {
                    const addBootstrapCSS = () => {
                        const link = document.createElement('link');
                        link.id = 'bootstrap-css';
                        link.rel = 'stylesheet';
                        link.href = '/static/bootstrap.min.css'; // Adjust path as necessary
                        document.head.appendChild(link);
                        console.log('Bootstrap CSS added after page loaded');
                    };

                    // Check if page is already loaded
                    if (document.readyState === 'complete' || document.readyState === 'interactive') {
                        addBootstrapCSS();
                    } else {
                        // Wait for page to load
                        document.addEventListener('DOMContentLoaded', addBootstrapCSS, { once: true });
                        window.addEventListener('load', addBootstrapCSS, { once: true });
                    }
                }

                const thermalStepInterval = setInterval(() => {
                    // Show thermal step page after adding Bootstrap CSS
                    const thermalPage = document.querySelector('.thermal-step-page');
                    if (thermalPage) {
                        //Ensure it runs after the CSS is applied
                        if (document.querySelector('#bootstrap-css, link[href*="bootstrap"]')) {
                            console.log('Thermal step page is now visible');
                            thermalPage.style.display = 'block';
                            clearInterval(thermalStepInterval);
                        }
                    }
                }, 2000); // Ensure it runs after the CSS is applied
                    
                // Store interval reference for cleanup
                window.thermalStepInterval = thermalStepInterval;
            } else {
                // console.log('Non-thermal step route');
                document.body.classList.remove('thermal-step-active');

                // Hide thermal step page
                document.querySelector('.thermal-step-page').style.display = 'none';

                // Remove Bootstrap CSS when not on thermal-step
                const bootstrapLink = document.querySelector('#bootstrap-css, link[href*="bootstrap"]');
                if (bootstrapLink) {
                    bootstrapLink.remove();
                    // console.log('Bootstrap CSS removed');
                }
            }

            // Update state only if path actually changed
            if (newPath !== currentPath) {
                console.log('Route changed from:', currentPath, 'to:', newPath);
                setCurrentPath(newPath);
            }
            
        };

        // Check initial route and on page load/reload
        checkRoute();

        // Listen for route changes
        window.addEventListener('popstate', checkRoute);
        
        // Listen for page load/reload
        window.addEventListener('load', checkRoute);
        window.addEventListener('DOMContentLoaded', checkRoute);
        
        // Listen for programmatic navigation
        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;
        
        history.pushState = function () {
            originalPushState.apply(this, arguments);
            setTimeout(checkRoute, 0);
        };
        
        history.replaceState = function () {
            originalReplaceState.apply(this, arguments);
            setTimeout(checkRoute, 0);
        };

        return () => {
            window.removeEventListener('popstate', checkRoute);
            window.removeEventListener('load', checkRoute);
            window.removeEventListener('DOMContentLoaded', checkRoute);
            history.pushState = originalPushState;
            history.replaceState = originalReplaceState;
            
            // Clear thermal step interval if it exists
            if (window.thermalStepInterval) {
                clearInterval(window.thermalStepInterval);
                window.thermalStepInterval = null;
            }
        };
    }, [currentPath]);

    return children;
};

const router = createBrowserRouter([{ path: '*', element: <App /> }]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <RouterMonitor>
        <RouterProvider router={router} />
    </RouterMonitor>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
